<template>
  <!-- data-tap-disabled  禁用ionic的点击系统 -->
  <micro-app
    v-bind="vueConfig"
    :data="microAppData"
    :data-tap-disabled="true"
    @datachange="processChildMsg"
  ></micro-app>
</template>

<script>
import { ref, reactive } from '@vue/reactivity'
import config from '@/appsConfig'
// @ is an alias to /src

export default {
  name: 'vueApp',
  setup() {
    const vueConfig = ref(config['vueApp'])
    const microAppData = reactive({})
    function processChildMsg(e) {
      console.log(e.detail.data)
    }
    return {
      processChildMsg,
      vueConfig,
      microAppData,
    }
  },
}
</script>
